var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPas9Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1122 1122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-linecap: round;\r\n        stroke-width: 57.74px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #323a89;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 57.74px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m911.62,996H222.42c-12.17,0-22.11-9.71-22.39-21.88-2.84-121.95-5.67-243.9-8.51-365.85-.28-12.16-10.23-21.88-22.39-21.88H55.43c-16.56,0-27.4-17.36-20.12-32.24,62.56-127.95,125.11-255.91,187.67-383.86,3.76-7.69,11.57-12.56,20.12-12.56h648.08c8.7,0,16.62,5.04,20.3,12.93l179.14,383.86c6.93,14.85-3.91,31.87-20.3,31.87h-113.9c-12.37,0-22.4,10.03-22.4,22.4v364.81c0,12.37-10.03,22.4-22.4,22.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m408.37,656.08c38.61,35.64,77.22,71.28,115.84,106.93,4.25,3.92,10.97,3.23,14.32-1.47,61.4-85.95,122.79-171.91,184.19-257.87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPas9Icon);
export default __webpack_public_path__ + "static/media/pas9Icon.b661db551aaaf39e82fc124abefa64d0.svg";
export { ForwardRef as ReactComponent };